import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./spinner.css.ts.vanilla.css-mistica.js";
var a = "_1fthc594 _1y2v1nfhq _1y2v1nfha", t = "_1fthc595", f = "_1y2v1nfhq _1y2v1nfha", h = "_1fthc597";
export { a as spinnerDefault, t as spinnerDefaultPath, f as spinnerIos, h as spinnerIosSvgPath };
